import { isNumber, memoizeFunction } from '@agilepoint/utils-common';
import { parseTime } from './utils';

export const timeValidator = {

    isValidHour(hour: string, is12Hour: boolean | undefined): boolean {
        return is12Hour ? this.isValid12Hour(hour) : this.isValid24Hour(hour);
    },

    isValid12Hour: memoizeFunction((hour = '01'): boolean => {
        if (isNumber(Number(hour)) && Number(hour) < 13) {
            if (Number(hour) === 0) {
                return false;
            }
            return true;
        }
        return false;
    }),

    isValid24Hour: memoizeFunction((hour = '00'): boolean => {
        if (isNumber(Number(hour)) && Number(hour) < 24) {
            return true;
        }
        return false;
    }),

    isValidMinute: memoizeFunction((minute = '00'): boolean => {
        if (!isNumber(Number(minute))) {
            return false;
        }
        if (minute[0] > '5') {
            return false;
        }
        return true;
    }),

    isValidSecond: memoizeFunction((second = '00'): boolean => {
        if (!isNumber(Number(second))) {
            return false;
        }
        if (second[0] > '5') {
            return false;
        }
        return true;
    }),

    isValidMeridiem: memoizeFunction((amPm = 'AM'): boolean => {
        if (amPm && (amPm.toLowerCase().startsWith('a') || amPm.toLowerCase().startsWith('p'))) {
            return true;
        }
        return false;
    }),

    isValidTime(time: string, timeSeperator: string): boolean {
        if (!time) {
            return false;
        }
        const [hour, minute, second, meridiem] = parseTime(time, timeSeperator);
        const isValidHour = this.isValidHour(hour!, time.toUpperCase().includes(meridiem));
        const isValidMinute = this.isValidMinute(minute);
        const isValidSecond = this.isValidSecond(second);
        const isValidAmPm = this.isValidMeridiem(meridiem);
        return isValidHour && isValidMinute && isValidSecond && isValidAmPm;
    }
};
